/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_design_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colour, contrast and screen tools for designers.`)
};

const es_cat_design_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas de color, contraste y pantalla para diseñadores.`)
};

const de_cat_design_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farb-, Kontrast- und Bildschirmtools für Designer.`)
};

const nl_cat_design_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleur-, contrast- en schermtools voor ontwerpers.`)
};

const fr_cat_design_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils de couleur, de contraste et d'écran pour designers.`)
};

const it_cat_design_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti di colore, contrasto e schermo per designer.`)
};

const pt_br2_cat_design_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de cor, contraste e tela para designers.`)
};

const pt_cat_design_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de cor, contraste e ecrã para designers.`)
};

const ja_cat_design_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デザイナー向けの色・コントラスト・画面ツール。`)
};

const zh_cat_design_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为设计师准备的色彩、对比度和屏幕工具。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_design_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_design_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_design_desc", locale)
	if (locale === "en") return en_cat_design_desc(inputs)
	if (locale === "es") return es_cat_design_desc(inputs)
	if (locale === "de") return de_cat_design_desc(inputs)
	if (locale === "nl") return nl_cat_design_desc(inputs)
	if (locale === "fr") return fr_cat_design_desc(inputs)
	if (locale === "it") return it_cat_design_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cat_design_desc(inputs)
	if (locale === "pt") return pt_cat_design_desc(inputs)
	if (locale === "ja") return ja_cat_design_desc(inputs)
	return zh_cat_design_desc(inputs)
};